import React from 'react'

import './style.css'
const Copyright = () => {
    return (
        <p className='copyright'>Copyright © 2022 Golden Dine website<br />All rights reserved</p>
    )
}

export default Copyright